"use client";

import { useTranslation } from "react-i18next";

export const Commitment = () => {
  const { t } = useTranslation();

  const images = [
    "/commit2.webp",
    "/s1.png",
     "/h1.webp",
    "/commit5.webp",
    "/about4.webp",
    "/green-house-main.webp",
    "/polycarbonate-main.webp",
    "/commit3.webp",
     "/h3.webp",
    "/polythene.webp",
    "/sustain4.webp",
    "/screenhouse-main.webp",
     "/h2.webp",
    "/s6.webp",
    "/commit4.webp",
    "/commit7.webp",
    "/sustain2.webp",
  ];

  return (
    <section className="w-full py-12 sm:py-16 overflow-hidden">

      {/* Heading */}
      <div className="flex flex-col items-center text-center max-w-4xl mx-auto px-5 gap-4">
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-[#002f37]">
          {t("commitment_heading")}
        </h2>

        <p className="text-base sm:text-lg text-[#002b04] max-w-2xl">
          {t("commitment_desc")}
        </p>
      </div>

      {/* Slider Wrapper */}
      <div className="mt-10 w-full overflow-hidden">
        
        <div className="flex w-max gap-3 md:gap-4 animate-slide">

          {[...images, ...images].map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt={`Image ${idx}`}
              loading="lazy"
              decoding="async"
              className="rounded-2xl object-cover
                w-[220px] h-[150px]
                sm:w-[260px] sm:h-[170px]
                md:w-[320px] md:h-[210px]
                lg:w-[380px] lg:h-[240px]"
            />
          ))}

        </div>
      </div>

      {/* Animation */}
      <style>{`
        @keyframes slide {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .animate-slide {
          animation: slide 55s linear infinite;
        }

        .animate-slide:hover {
          animation-play-state: paused;
        }
      `}</style>

    </section>
  );
};